import isBoolean from 'lodash-es/isBoolean';
import React, { forwardRef } from 'react';
import styled from 'styled-components';

import { Flex } from '../../../components/Flex';
import { Text } from '../../../components/Text';
import { Textarea, TextareaProps } from '../../../components/Textarea';
import { Breakpoints } from '../../../theme/Breakpoints';
import { Rounded } from '../../../theme/Rounded';
import { Spacing } from '../../../theme/Spacing';

const InputWrapper = styled(Flex)<{ error?: boolean }>`
  border-radius: ${Rounded.md};
  padding-block: 0.2rem;
  flex-direction: column;
  gap: ${Spacing.s};

  @media (min-width: ${Breakpoints.DESKTOP}) {
    flex-direction: row;
    gap: 0;
    background-color: ${({ theme }) => theme.bgSpecialInput};
    padding-inline-start: ${Spacing.s};
    outline: 2px solid
      ${({ theme, error }) => (error ? theme.danger : 'transparent')};
  }
`;

const InputLabel = styled(Text)`
  color: ${({ theme }) => theme.main};
  font-weight: 600;
  white-space: nowrap;

  @media (min-width: ${Breakpoints.DESKTOP}) {
    color: ${({ theme }) => theme.labelSpecialInput};
  }
`;

const StyledTextarea = styled(Textarea)<{ error?: boolean }>`
  background-color: ${({ theme }) => theme.bgSpecialInput};
  border: 0 !important;
  font-weight: 600;
  resize: vertical;
  padding: 0 ${Spacing.s} !important;
  color: ${({ theme }) => theme.fgSpecialInput};

  @media (max-width: ${Breakpoints.DESKTOP}) {
    outline: 2px solid
      ${({ theme, error }) => (error ? theme.danger : 'transparent')} !important;
  }

  @media (min-width: ${Breakpoints.DESKTOP}) {
    background-color: ${({ theme }) => theme.transparent};
    border: 0 !important;
  }
`;

const DangerSpan = styled.span`
  color: ${({ theme }) => theme.danger};
`;

type LinkTextareaProps = TextareaProps;

export const LinkTextarea = forwardRef<HTMLTextAreaElement, LinkTextareaProps>(
  ({ title, valid, errorMessage, ...props }, ref) => {
    return (
      <Flex width={'100%'} flexDirection="column" gap="s">
        <InputWrapper error={isBoolean(valid) && !valid}>
          <InputLabel>
            {props?.required ? <DangerSpan>* </DangerSpan> : null}

            {title}
          </InputLabel>

          <StyledTextarea error={isBoolean(valid) && !valid} {...props} />
        </InputWrapper>

        {!valid && errorMessage ? (
          <Text color="danger" fontSize="s">
            {errorMessage}
          </Text>
        ) : null}
      </Flex>
    );
  },
);
